import React from 'react';
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
} from 'react-share';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import styles from './socialMediaLinks.module.scss';

type SocialMediaLinksProps = {
    url: string;
};

const SocialMediaLinks = ({ url }: SocialMediaLinksProps) => (
    <DefaultWidthContainer extraClassNames={styles.socialMediaLinks}>
        <p className={styles.tekst}>Share: </p>{' '}
        <FacebookShareButton url={url} style={{ width: 'inherit', margin: '4px' }}>
            <FacebookIcon size={25} round={true} />
        </FacebookShareButton>
        <TwitterShareButton url={url} style={{ width: 'inherit', margin: '4px' }}>
            <TwitterIcon size={25} round={true} />
        </TwitterShareButton>
        <LinkedinShareButton url={url} style={{ width: 'inherit', margin: '4px' }}>
            <LinkedinIcon size={25} round={true} />
        </LinkedinShareButton>
    </DefaultWidthContainer>
);

export default SocialMediaLinks;
